import { ActivityTypeDto, RecipeTemplateStep } from '@/api/ApiClient';

/**
 * Maps activity type or string to RecipeTemplateStep for the recipe-templates API.
 * Only PREP, SYN, POST are valid; other activity types return null.
 */
export function toRecipeTemplateStep(
  value: ActivityTypeDto | string | null | undefined
): RecipeTemplateStep | null | undefined {
  if (value == null || value === undefined) return value as undefined;
  if (typeof value === 'string') {
    if (value === 'PREP' || value === 'SYN' || value === 'POST') return value as RecipeTemplateStep;
    return null;
  }
  switch (value) {
    case ActivityTypeDto.Preparation:
      return RecipeTemplateStep.PREP;
    case ActivityTypeDto.Synthesis:
      return RecipeTemplateStep.SYN;
    case ActivityTypeDto.PostTreatment:
      return RecipeTemplateStep.POST;
    default:
      return null;
  }
}
